import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import Select from 'react-select'

import { httpOk, GET, POST, PUT } from 'helpers/api'
import { checkYandexMapKey } from 'helpers/yandexMapKey'
import { docsPageUrl } from 'helpers/apps'

function Index() {
	const { t, i18n } = useTranslation()

	const [data, setData] = useState({
		'id': "",
		'token': "",
		'map_type_id': "",
	})
	const [mapTypes, setMapTypes] = useState([])
	// null — не проверяли, 'checking' — идёт проверка, 'ok' / 'fail' — результат
	const [keyCheck, setKeyCheck] = useState(null)

	const isYandex = mapTypes.find(option => option.id === data.map_type_id)?.value === 'yandex'

	// Ключ Яндекса проверяем настоящим поиском адреса: иначе неверный ключ сохраняется молча,
	// а в колл-центре поиск адреса просто ничего не находит
	async function verifyKey() {
		setKeyCheck('checking')
		const result = await checkYandexMapKey(data.token)
		setKeyCheck(result.ok ? 'ok' : 'fail')
		return result.ok
	}

	async function searchWithFilter() {
		var filterUrl = `/chain/maps`

		var response = await GET(filterUrl, {}, { loader: true })
		// настройки может не быть вовсе — тогда форма пустая
		if (httpOk(response)) setData(response.data ?? { 'id': "", 'token': "", 'map_type_id': "" });
	}

	async function createUpdate(e) {
		e.preventDefault()

		if (isYandex && data.token && !(await verifyKey())) return

		var response;
		if (data.id) {
			response = await PUT('/chain/maps', data, { loader: true })
		} else {
			response = await POST('/chain/maps', data, { loader: true })
		}

		if (httpOk(response)) searchWithFilter()
	}

	async function getMapTypes() {
		const response = await GET('/helper/map-types')
		if (httpOk(response)) setMapTypes(response.data)
	}

	useEffect(() => {
		searchWithFilter()
		getMapTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('geocoding')}
					</h4>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="row">
						<div className="col-md-4">
							<div className="form-group">
								<label>{t('type')}</label>
								<Select
									isClearable
									options={mapTypes}
									value={mapTypes.find(option => option.id === data.map_type_id) || null}
									onChange={(option) => setData({ ...data, 'map_type_id': option ? option.id : null, 'website': option ? option.website : '' })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="d-flex gap-2">
								<p>{t('website')}:</p>
								<Link to={data.website ?? ''}>
									{data.website}
								</Link>
							</div>

							<div className="form-group">
								<label>TOKEN</label>
								<input type="text" className="form-control" name="token"
									autoComplete="off"
									value={data.token ?? ''}
									onChange={(e) => {
										setData({ ...data, 'token': e.target.value })
										setKeyCheck(null)
									}} />
							</div>

							{/* Какой продукт выбирать в кабинете Яндекса: ключ «JavaScript API» нового кабинета
								геокодер не принимает, поиск адреса с ним не работает (helpers/yandexGeocoder) */}
							{isYandex &&
								<div className="alert alert-info py-2 small">
									{t('map_key_hint')}{' '}
									<a href={docsPageUrl('external_geocoding', i18n.language)} target="_blank" rel="noreferrer">
										{t('map_key_guide')}
									</a>
								</div>
							}

							{isYandex &&
								<div className="mb-3">
									<button type="button" className="btn btn-sm btn-outline-primary"
										disabled={!data.token || keyCheck === 'checking'}
										onClick={() => verifyKey()}>
										{keyCheck === 'checking' ? t('map_key_checking') : t('map_key_check')}
									</button>
									{keyCheck === 'ok' &&
										<div className="text-success mt-2">{t('map_key_ok')}</div>
									}
									{keyCheck === 'fail' &&
										<div className="text-danger mt-2">{t('map_key_fail')}</div>
									}
								</div>
							}
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/external-integrations">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide"
							onClick={(e) => createUpdate(e)}>
							{t('save')}
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index